import { render, staticRenderFns } from "./h-banner-2500.vue?vue&type=template&id=a5b18160&scoped=true"
import script from "./h-banner-2500.vue?vue&type=script&lang=js"
export * from "./h-banner-2500.vue?vue&type=script&lang=js"
import style0 from "./h-banner-2500.vue?vue&type=style&index=0&id=a5b18160&prod&lang=scss"
import style1 from "./h-banner-2500.vue?vue&type=style&index=1&id=a5b18160&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5b18160",
  null
  
)

export default component.exports